import { Badge } from "@/components/ui/badge";

interface EmailAddressRowProps {
  label: string;
  addresses: string[];
  emptyLabel: string;
  isExternal?: (address: string) => boolean;
}

/**
 * Labeled email header row listing every address in full, marking external ones.
 * @param props - The row label, its addresses, the text shown when empty, and an external check
 * @returns The rendered header row
 */
export function EmailAddressRow({
  label,
  addresses,
  emptyLabel,
  isExternal,
}: EmailAddressRowProps) {
  return (
    <div className="flex gap-2">
      <span className="w-12 shrink-0 font-medium text-muted-foreground">
        {label}:
      </span>
      {addresses.length === 0 ? (
        <span className="text-muted-foreground">{emptyLabel}</span>
      ) : (
        <div className="flex min-w-0 flex-wrap gap-x-3 gap-y-1">
          {addresses.map((address, index) => (
            <span
              key={`${index}-${address}`}
              className="inline-flex min-w-0 items-center gap-1.5"
            >
              <span className="break-all text-foreground">{address}</span>
              {isExternal?.(address) && (
                <Badge variant="outline" className="px-1.5 py-0 font-medium">
                  External
                </Badge>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
